import { OrderSortType } from "./groupHeaders";
export interface ISortItem {
  title: string;
  value: OrderSortType;
}

export interface IFilterOption {
  title: string;
  value: string | number | boolean;
  helperText?: string;
}

export interface IFilterItem {
  key: string;
  title: string;
  options: IFilterOption[];
}

export const usedCodesSortTypes: ISortItem[] = [
  {
    title: "Used Date",
    value: "UsedDate",
  },
  {
    title: "Start Date",
    value: "StartDate",
  },
  {
    title: "End Date",
    value: "Expires",
  },
  {
    title: "Discount Type",
    value: "DiscountType",
  },
  {
    title: "Use Type",
    value: "UseType",
  },
  {
    title: "Min. Spend Required",
    value: "MinimumSpend",
  },
  {
    title: "Status",
    value: "Active",
  },
  {
    title: "Code Type",
    value: "CodeType",
  }
];

export const sortTypes: ISortItem[] = [
  {
    title: "Start Date",
    value: "StartDate",
  },
  {
    title: "End Date",
    value: "Expires",
  },
  {
    title: "Discount Type",
    value: "DiscountType",
  },
  {
    title: "Use Type",
    value: "UseType",
  },
  {
    title: "Min. Spend Required",
    value: "MinimumSpend",
  },
  {
    title: "Status",
    value: "Active",
  },
  {
    title: "Code Type",
    value: "CodeType",
  }
];

export const referralCodesSortTypes: ISortItem[] = [
  {
    title: "Name",
    value: "Name",
  },
  {
    title: "Start Date",
    value: "StartDate",
  },
  {
    title: "End Date",
    value: "Expires",
  },
  {
    title: "Discount Type",
    value: "DiscountType",
  },
  {
    title: "Use Type",
    value: "UseType",
  },
  {
    title: "Min. Spend Required",
    value: "MinimumSpend",
  },
  {
    title: "Status",
    value: "Active",
  }
];

export const filterOptions: IFilterItem[] = [
  {
    key: "DiscountType",
    title: "Discount Type",
    options: [
      { title: "Fixed Amount", value: "Value" },
      { title: "Percentage", value: "Percent" },
    ],
  },
  {
    key: "UseType",
    title: "Use Type",
    options: [
      { title: "Single Use", value: "SingleUse" },
      { title: "Multi Use", value: "MultiUse" },
      { title: "Once Per User", value: "OncePerCustomer" },
    ],
  },
  {
    key: "MinimumSpend",
    title: "Minimum Spend",
    options: [
      { title: "Yes", value: true },
      { title: "No", value: false },
    ],
  },
  {
    key: "Status",
    title: "Status",
    options: [
      { title: "Active", value: true },
      { title: "Archived", value: false },
    ],
  },
  {
    key: "CodeType",
    title: "Code Type",
    options: [
      { title: "Promotional Code", value: "PromotionalCode" },
      { title: "Referral Voucher", value: "ReferralVoucher" },
    ],
  }
];

export const referralCodefilterOptions: IFilterItem[] = [
  {
    key: "DiscountType",
    title: "Discount Type",
    options: [
      { title: "Fixed Amount", value: "Value" },
      { title: "Percentage", value: "Percent" },
    ],
  },
  {
    key: "UseType",
    title: "Use Type",
    options: [
      { title: "Single Use", value: "SingleUse" },
      { title: "Multi Use", value: "MultiUse" },
      { title: "Once Per User", value: "OncePerCustomer" },
    ],
  },
  {
    key: "Status",
    title: "Status",
    options: [
      { title: "Active", value: true },
      { title: "Archived", value: false },
    ],
  },
];


export const usedCodesFilterOptions: IFilterItem[] = [
  {
    key: "DiscountType",
    title: "Discount Type",
    options: [
      { title: "Fixed Amount", value: "Value" },
      { title: "Percentage", value: "Percent" },
    ],
  },
  {
    key: "UseType",
    title: "Use Type",
    options: [
      { title: "Single Use", value: "SingleUse" },
      { title: "Multi Use", value: "MultiUse" },
      { title: "Once Per User", value: "OncePerCustomer" },
    ],
  },
  {
    key: "MinimumSpend",
    title: "Minimum Spend",
    options: [
      { title: "Yes", value: true },
      { title: "No", value: false },
    ],
  },
  {
    key: "Status",
    title: "Status",
    options: [
      { title: "Active", value: true },
      { title: "Archived", value: false },
    ],
  },
  {
    key: "CodeType",
    title: "Usage Type",
    options: [
      { title: "Promotional Code", value: "PromoCodeUsage" },
      { title: "Voucher", value: "VoucherUsage" },
      { title: "Referral Code", value: "ReferralUsage" },
    ],
  }
];
